// Gera SVG de QR Code para cada template, para thumb realista
import { generateLocalQR } from './qrLocal';

export async function getTemplateSVG({
  data = 'https://qrcodexpress.com',
  body,
  eye,
  eyeBall,
  bodyColor,
  bgColor,
  gradient,
  gradientColor1,
  gradientColor2,
  gradientType = 'linear',
  size = 120,
}) {
  const config = {
    body,
    eye,
    eyeBall,
    bodyColor,
    bgColor,
    gradient: !!gradient,
    gradientColor1: gradient ? gradientColor1 : null,
    gradientColor2: gradient ? gradientColor2 : null,
    gradientType,
  };
  // Gera SVG real do QR Code
  const svgDataUrl = await generateLocalQR({
    data,
    config,
    size,
    file: 'svg',
  });
  // Extrai SVG puro do dataURL
  if (svgDataUrl.startsWith('data:image/svg+xml;base64,')) {
    const svg = atob(svgDataUrl.replace('data:image/svg+xml;base64,', ''));
    return svg;
  }
  if (svgDataUrl.startsWith('data:image/svg+xml;utf8,')) {
    return decodeURIComponent(svgDataUrl.replace('data:image/svg+xml;utf8,', ''));
  }
  return '';
}
